module.exports = __webpack_public_path__ + "static/media/prior_logo.5af25e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prior_logo.png
// module id = 432
// module chunks = 0